import { useCallback, useMemo } from 'react'

import { BadgeDatabase, TBadge } from '@/entities/user'

export const useBadgeDatabase = () => {
  const badgeDatabase = useMemo(() => new BadgeDatabase(), [])

  const getBadges = useCallback(
    (userId: number) => {
      return badgeDatabase.getBadges(userId)
    },
    [badgeDatabase],
  )

  const subscribeBadges = useCallback(
    (userId: number, onUpdate: (badge: TBadge) => void) => {
      return badgeDatabase.subscribeBadges(userId, onUpdate)
    },
    [badgeDatabase],
  )

  return { getBadges, subscribeBadges }
}
